import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, coreTheme, Text } from "@kolmeo/ui-core";
import Icon from "../Icon";
const FieldError = ({ message }) => {
    const { palette } = coreTheme;
    return (_jsxs(Box, { alignItems: "center", flexDirection: "row", children: [_jsx(Icon, { type: "alert-circle", size: "xxs", color: palette.danger }), _jsx(Text, { variant: "paragraph12", ml: "6px", color: palette.danger, children: message })] }));
};
export default FieldError;
